import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Truck } from "lucide-react";
import { http, fmtErr } from "../lib/api";

const CARRIERS = [
  { value: "", label: "Carrier…" },
  { value: "usps", label: "USPS" },
  { value: "ups", label: "UPS" },
  { value: "fedex", label: "FedEx" },
  { value: "dhl", label: "DHL" },
  { value: "other", label: "Other" },
];

const STATUSES = [
  { value: "processing", label: "Processing" },
  { value: "shipped", label: "Shipped (notify customer)" },
  { value: "delivered", label: "Delivered" },
];

export function FulfillmentRow({ order, onUpdated }) {
  const [tracking, setTracking] = useState(order.tracking_number || "");
  const [carrier, setCarrier] = useState(order.carrier || "");
  const [status, setStatus] = useState(order.fulfillment_status || "processing");
  const [url, setUrl] = useState(order.tracking_url || "");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await http.post(`/admin/orders/${order.id}/fulfillment`, {
        tracking_number: tracking, carrier, status, tracking_url: url,
      });
      toast.success(data.notified ? "Saved · customer notified" : "Saved");
      onUpdated?.(data.order);
    } catch (err) { toast.error(fmtErr(err.response?.data?.detail) || "Failed"); }
    finally { setSaving(false); }
  };

  const input = "bg-white border border-[#E5D8C1] px-3 py-2 text-sm w-full focus:outline-none focus:border-[#D32F2F]";

  return (
    <div className="mt-2 flex flex-wrap gap-2 items-center" data-testid={`fulfillment-${order.id}`}>
      <input value={tracking} onChange={(e) => setTracking(e.target.value)} placeholder="Tracking #" className={input + " flex-1 min-w-[140px]"} data-testid={`fulfillment-tracking-${order.id}`} />
      <select value={carrier} onChange={(e) => setCarrier(e.target.value)} className={input + " w-32"} data-testid={`fulfillment-carrier-${order.id}`}>
        {CARRIERS.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
      </select>
      <select value={status} onChange={(e) => setStatus(e.target.value)} className={input + " w-52"} data-testid={`fulfillment-status-${order.id}`}>
        {STATUSES.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
      </select>
      <input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="Tracking URL (optional)" className={input + " flex-1 min-w-[160px]"} data-testid={`fulfillment-url-${order.id}`} />
      <button onClick={save} disabled={saving} className="bg-[#1A1A1A] text-white hover:bg-[#D32F2F] px-4 py-2 text-xs uppercase tracking-widest font-heading disabled:opacity-60 flex items-center gap-1.5" data-testid={`fulfillment-save-${order.id}`}>
        {saving ? <Loader2 className="animate-spin" size={14} /> : <Truck size={14} />} Save
      </button>
    </div>
  );
}
